export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '업체명'}, {name: '평가일'}, {name: '평가점수'}, {name: '소속명'}, {name: '부서명'}, {name: '작성일'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 사업장명
        case 1: return func.getContent(value).companyName // 업체명
        case 2: return func.getContent(value).stdInfo.평가일 // 평가일
        case 3: return func.getContent(value).userScore // 평가점수
        case 4: return func.getContent(value).stdInfo.department // 소속명
        case 5: return func.getContent(value).stdInfo.section // 부서명
        case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
    // [{name: '사업장명'}, {name: '업체명'}, {name: '평가자'}, {name: '평가일'}, {name: '평가점수'}, {name: '소속명'}, {name: '부서명'}, {name: '작성자'}, {name: '작성일'}]
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
      case '사업장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
      case '업체명': returnData.push('content$body.companyName*%[:default_skw]%'); break
      case '평가자': returnData.push('content$body.stdInfo."평가자"*%[:default_skw]%'); break
      case '평가일': returnData.push('content$body.stdInfo."평가일"*%[:default_skw]%'); break
      case '평가점수': returnData.push('content$body.userScore*%[:default_skw]%'); break
      case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
      case '부서명': returnData.push('content$body.stdInfo.section*%[:default_skw]%'); break
      case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
